import { TransferAssetService } from '../model/transfer-asset.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { TransferAsset } from 'assets-model';
import { Observable } from 'rxjs';


export class TransferAssetDataSource extends CrudDataSource<TransferAsset> {

  constructor(private service: TransferAssetService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<TransferAsset>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}

export class PendingTransferAssetApprovalDataSource extends CrudDataSource<TransferAsset> {

  constructor(private service: TransferAssetService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<TransferAsset>> {
    return this.service.findAllUnapproved(pageSpec);
  }

}
